//#region ../src/utils.js
var e = 0, t = () => `dt-icon${e++}`;
//#endregion
export { t };

//# sourceMappingURL=utils-C1uyTI6x.js.map